import { User } from '@wavingroup/iot-core/gen/ts/wavin/ignite/v1/user_pb';
import { igniteUserPromiseClient } from '~/services/ignite-client';

export const patchUser = async ({
  user,
}: {
  user?: Partial<Omit<User, '$typeName'>>;
}) =>
  await igniteUserPromiseClient.patchUser({
    user,
  });

export const getUser = async () =>
  await igniteUserPromiseClient.getUser({ name: 'users/me' });
